import { render, staticRenderFns } from "./DialogBindWechat.vue?vue&type=template&id=02600a2a&scoped=true&"
import script from "./DialogBindWechat.vue?vue&type=script&lang=ts&"
export * from "./DialogBindWechat.vue?vue&type=script&lang=ts&"
import style0 from "./DialogBindWechat.vue?vue&type=style&index=0&id=02600a2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02600a2a",
  null
  
)

export default component.exports